import { useEffect } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import ListingSearchCriteria from './Criteria/ListingSearchCriteria';

interface RouteParams {
  marketSlug: string;
}

type Options = {
  onUrlChange: (criteria: ListingSearchCriteria) => void;
};

const useListingSearchCriteria = (options: Partial<Options> = {}) => {
  const { marketSlug } = useParams<RouteParams>();
  const { search: queryString } = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();

  const criteria = new ListingSearchCriteria({ queryString, marketSlug, history, dispatch });

  useEffect(() => {
    if (options.onUrlChange) options.onUrlChange(criteria);
  }, [queryString, marketSlug]);

  return criteria;
};

export default useListingSearchCriteria;
